import { Component, Input, viewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { SchedulerOptionsComponent } from '../scheduler-options-component';
import { ContinuationMode, DailySchedulerDefinition, DayOfWeek, Frequency, SchedulerDefinition } from '../../../../api/scheduler-service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

@Component({
  selector: 'daily-schedule-options',
  imports: [
    CommonModule, MatCardModule, MatSlideToggleModule,
    MatButtonToggleModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    MatChipsModule, MatIconModule, MatTooltipModule, NgxMatTimepickerModule,
  ],
  templateUrl: './daily-schedule-options.component.html',
  styleUrl: './daily-schedule-options.component.css'
})
export class DailyScheduleOptionsComponent implements SchedulerOptionsComponent{

  @Input() valueChange : Function | undefined;

  continuationModes = Object.values(ContinuationMode);


  interval : FormControl = new FormControl(1, Validators.min(1));
  weekdays = Object.values(DayOfWeek);
  selectedWeekdays : FormControl = new FormControl([]);
  dependency: FormControl = new FormControl(false);
  continuationMode: FormControl = new FormControl(ContinuationMode.Strict);
  /** "HH:mm" string the wire format expects. Empty = no executionTime set. */
  executionTime : FormControl = new FormControl('');

  dailyOptionsForm: FormGroup = new FormGroup(
    {
      "interval" : this.interval,
      "selectedWeekdays" : this.selectedWeekdays,
      "dependency" : this.dependency,
      "continuationMode" : this.continuationMode,
      "executionTime" : this.executionTime,
    }
  );

  constructor() {

  }

  ngOnInit(): void {
    this.selectedWeekdays.valueChanges.subscribe((v) => this.interval?.setValue(1, {emitEvent: false}));
    this.interval?.valueChanges.subscribe((v) => this.selectedWeekdays.setValue([], {emitEvent: false}));
    setTimeout(() => this.dailyOptionsForm.valueChanges.subscribe(() => {
      if (this.valueChange != undefined) {
        this.valueChange();
      }
    }), 0);
  }

  getSchedulerDefinition() : SchedulerDefinition {
    const schedulerDefinition: DailySchedulerDefinition = {
      frequency: Frequency.Daily,
      interval: this.interval.value,
      weekdays: this.selectedWeekdays.value,
      eventDependency: this.dependency.value,
      continuationMode: this.continuationMode.value,
    };
    // executionTime isn't on the generated DailySchedulerDefinition type yet
    // (server spec hasn't been regenerated with the new field). Cast so it
    // still makes it onto the wire payload — Jackson on the backend
    // deserialises via @JsonFormat HH:mm. Cast goes away on next client regen.
    const tod = this.executionTime.value?.trim();
    if (tod) {
      (schedulerDefinition as any).executionTime = tod;
    }
    return schedulerDefinition;
  }
  getIntervalSuffix() : string {
    return (this.interval.value > 1) ? "days" : "day";
  }

  intervalHasError() : boolean {
    return !this.interval.valid;
  }

  intervalErrorMessage() : string {
    if (this.interval.hasError("min")) {
      return "Interval must be 1 or higher";
    }

    return "";
  }

}
